module.exports = __webpack_public_path__ + "img/Checkmark.552a6121.svg";